import { useEffect, useState } from "react";
import CustomInput from "../genericComponents/CustomInput";
import { Grid2, Button } from "@mui/material";
import { DateTime } from "luxon"
import { FilterList } from "@mui/icons-material";
const DateFilterSideScreen = ({ data, setHeader, notifyParent, close }) => {

    const save = () => {
        notifyParent({ start: DateTime.fromFormat(start, 'yyyy-MM-dd'), end: DateTime.fromFormat(end, 'yyyy-MM-dd') })
        close();
    }
    useEffect(() => {
        setHeader({icon:FilterList,text:"Datum filter"});
    }, [setHeader])


    const [start, setStart] = useState(data.start.toFormat("yyyy-MM-dd"));
    const setDate = (func, value) => {        
        func(value);
    }    
    const [end, setEnd] = useState(data.end.toFormat("yyyy-MM-dd"));
    
    return <Grid2 container spacing={1}>        
        <CustomInput
            onChange={e => setDate(setStart, e)}
            type="Date"
            value={start}
            placeholder={`Van`}
        />
        <CustomInput
            onChange={e => setDate(setEnd, e)}
            type="Date"
            value={end}
            placeholder={`Tot`}
        />
        <Button onClick={save} sx={{color:"white"}} fullWidth variant="contained">Save</Button>
    </Grid2>
}
export default DateFilterSideScreen;